import type { Component } from "solid-js";
import type { IconProps } from "./types";

const DotSeparatorIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 2;
  return (
    <svg viewBox="0 0 2 2" fill="currentColor" width={size} height={size} class={props.class}>
      <circle cx="1" cy="1" r="1" />
    </svg>
  );
};

export default DotSeparatorIcon;
